import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconUploadCloud = ({ className = '', color = '#444', height = 13, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`icon-upload-cloud ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 13"
        width={width}
    >
        <g className="fill-color" fill={color}>
            <path d="M8.5 6.1v6.8h-1V6.1L5.4 8.3l-.8-.8L8 4.2l3.3 3.4-.7.7-2.1-2.2z" />
            <path d="M10 12.9h1.5c2.5 0 4.4-2.3 4.4-5.1 0-2.7-2.1-4.8-4.9-4.9l1 1C12 1.6 10.3.1 8 0 4.9-.2 2.9 1.6 3 4.9l.9-1C1.8 4.1.1 6.2.1 8.5c0 2.4 1.6 4.4 3.8 4.4H6v-1H3.9C2.3 11.9 1 10.4 1 8.5 1.1 6.7 2.5 5 4 4.9 3.9 2.1 5.6.8 8 .9c1.7.1 3 1.1 3 2.9 2.3 0 3.9 1.7 3.9 3.9 0 2.3-1.5 4.1-3.4 4.1H10v1.1z" />
        </g>
        <path
            className="fill-color"
            d="M11.8 2.7s.2.5.2.9-1-.4-1-.4l-.1-.5h.9zm-8.7 1s-.1.5-.1.7.9-.5.9-.5l-.8-.2z"
            fill={color}
        />
    </AccessibleSVG>
);

export default IconUploadCloud;
